module.exports = __webpack_public_path__ + "img/icon-blank.b1839e30.svg";